import { ErroModel } from './erro.model';

export class UsuarioLogadoModel {
  constructor(
    public id: string,
    public idPerfil: string,
    public nome: string,
    public email: string,
    public token: string,    
    public iniciais: string,
    public instituicaoAssociada?: string) { }
}

export class UsuarioConsultaRequestModel {
  public nomeOuEmail: string;
  public idPerfil: number;
  public idStatusUsuario: number;
  public paginaSolicitada: number;
  public paginaQuantidade: number;
}

export class UsuarioConsultaResponseModel {
  public quantidadeUsuarios: number;
  public usuarios: usuarios[];
}

export class usuarios {
  public id: number;
  public nome: string;
  public email: string;
  public cnpj: string;
  public perfil: string;
  public perfilDescricao: string;
  public status: string;
  public erros: ErroModel[]
}

export class UsuarioExcluirRequestModel {
  public id: number;
}

export class UsuarioExcluirResponseModel {
  public erros: ErroModel[]
}

export class UsuarioInativarResponseModel {
  public id: number;
  public erros: ErroModel[]
}

export class UsuarioReenviarEmailRequestModel {
  public id: number;
}

export class UsuarioReenviarEmailResponseModel {
  public erros: ErroModel[]
}

export class UsuarioCadastroRequestModel {
  public id: number;
  public nome: string;
  public email: string;
  public idPerfil: number;
  public cpf: string;
}

export class UsuarioCadastroAssociadosRequestModel {
  public nome: string;
  public email: string;
  public cnpj: string;
}

export class UsuarioObterResponseModel {
  public id: number;
  public nome: string;
  public email: string;
  public cnpj: string;
  public idPerfil: number;
  public idInstituicaoAssociada: number;
  public idUsuarioStatus: number;
}

export class UsuarioCadastroResponseModel {
  public id: number;
  public erros: ErroModel[]
}
